<template>
    <div class="fixed top-20 bottom-4 right-4 pointer-events-none" v-bind="$attrs">
        <div
            class="flex flex-col-reverse flex-wrap-reverse gap-x-5 gap-y-5 items-end content-start w-none h-full"
        >
            <!-- 지금은 페이롤이 먼저 쌓이고 타임리포트는 그 위에 쌓임 순서대로 쌓이는 요구가 들어오면 그때... 고쳐...  -->
            <designPayrollStack
                v-if="
                    $appUtil.checkPermission('PAYROLL_SETTING_EDIT') ||
                    $appUtil.checkSubscription('PAYROLL_USAGE')
                "
            />
            <timeReportUploadPanel
                v-if="
                    $appUtil.checkPermission('ATTENDANCE_VIEW') ||
                    $appUtil.checkPermission('ATTENDANCE_EDIT')
                "
            />
        </div>
    </div>
</template>

<script>
import designPayrollStack from '@/components/design-system/design-payroll-stack.vue';
import timeReportUploadPanel from '@/pages/time/time_reports/time-report-upload-pannel.vue';

export default {
    components: {
        designPayrollStack,
        timeReportUploadPanel,
    },
};
</script>
